/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import Countries from './registerCountriesData';

import RegisterAddress from './RegisterAddress';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputField from 'custom/LoginForm/Input';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const FocusArrow = () => (
  <svg viewBox="0 0 20 20" className="focusArrow">
    <path d="M0 0 L10 10 L0 20" />
  </svg>
);

const InputLine = () => (
  <svg className="inputLine" viewBox="0 0 40 2" preserveAspectRatio="none">
    <path d="M0 1 L40 1" />
    <path d="M0 1 L40 1" className="activeFocus" />
  </svg>
);

const RegisterPage = ({
  items, pageNumber, nextPage, prevPage, change, handleBubbleClick, userInput, setAddress, country
}) => {
  const {
    title, accent, intro, bubbles, options, id, multiple,
  } = items;

  const [selectedBubble, setSelectedBubble] = useState('');

  // select bubble and set to storage for when user goes to prev or next page and back
  const bubbleClick = async (bubble, e) => {
    // get previously selected bubbles from storage
    const registerBubbles = await StorageHandler.load(storageKeys.registerBubbles);
    // find index of current page
    const storedBubble = registerBubbles.findIndex(i => i.page === pageNumber);
    // if selected bubble is clicked again, remove from storage and state
    if (selectedBubble === bubble.id) {
      setSelectedBubble('');
      registerBubbles[storedBubble].bubble = '';
      StorageHandler.save(storageKeys.registerBubbles, registerBubbles);
      handleBubbleClick(id, '');
    } else if (multiple) {

      // If bubble exists already remove it from storage and state
      if (registerBubbles[storedBubble].bubble.includes(bubble.id)) {
        registerBubbles[storedBubble].bubble = registerBubbles[storedBubble].bubble.filter(item => item !== bubble.id);
      } else {

        // Limit to 3 bubbles
        if (registerBubbles[storedBubble].bubble.length >= 3) {
          toast.error('You can only select 3 bubbles', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            transition: Zoom,
          });
          return;
        }

        // If bubble does not exist add it to storage and state
        registerBubbles[storedBubble].bubble.push(bubble.id);
      }

      setSelectedBubble(bubble.id);
      StorageHandler.save(storageKeys.registerBubbles, registerBubbles);
      handleBubbleClick(id, bubble.id);

      // When two or more items are highlighted go to next page
      if (registerBubbles[storedBubble].bubble.length >= 3) {
        // setTimeout(() => {
        //   nextPage(e);
        // }, 0);
      }
    } else {
      setSelectedBubble(bubble.id);
      registerBubbles[storedBubble].bubble = bubble.id;
      StorageHandler.save(storageKeys.registerBubbles, registerBubbles);
      handleBubbleClick(id, bubble.id);

      // setTimeout(() => {
      //   nextPage(e);
      // }, 1000);
    }
  };

  const buttonClick = (direction, e) => {
    e.preventDefault();
    if ((bubbles && selectedBubble === '' && direction !== 'prev')) {
      toast.error('Please choose a bubble', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (bubbles && selectedBubble.length < 3 && direction !== 'prev') {
      toast.error('Please select your top 3 bubbles', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (direction === 'prev') {
      prevPage(e);
      setSelectedBubble(null);
    } else if (direction === 'next') {
      nextPage(e);
      setSelectedBubble(null);
    }
  };

  const loadSelectedBubbles = async () => {
    const registerBubbles = await StorageHandler.load(storageKeys.registerBubbles);
    if (registerBubbles) {
      const prevSelectBubble = registerBubbles.filter(i => i.page === pageNumber)[0];
      if (prevSelectBubble) {
        setSelectedBubble(prevSelectBubble.bubble);
        handleBubbleClick(id, prevSelectBubble.bubble);
      }
    }
  };

  const handleEnter = (event) => {
    if (event.key.toLowerCase() === 'enter') {
      const { form } = event.target;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };

  useEffect(() => {
    loadSelectedBubbles();
  });

  const height = 460;

  // TODO: Move to components
  return (
    <React.Fragment>
      <div className="Register__title">
        <h1>
          {title}
          <span>{accent}</span>
        </h1>
        <p>{intro}</p>
      </div>
      <ToastContainer
        draggablePercent={70}
      />
      <div
        className={`Register__form ${bubbles ? 'bubbles' : ''} page-${pageNumber}`}
        style={{ minHeight: bubbles ? height : 'inherit' }}
      >
        {!bubbles && options.map((item, i) => {
          if (item.type === 'text' || item.type === 'email' || item.type === 'password') {
            if (item.type === 'email') {
              return (
                <React.Fragment>
                <label>{item.name}</label>
                <input
                  key={i}
                  type={item.type}
                  id={item.id}
                  placeholder={item.name}
                  onChange={change}
                  defaultValue={userInput[item.id]}
                  required={item.required}
                />
                </React.Fragment>
              );
            }
            return (
              <React.Fragment>
              <label>{item.name}</label>
              <input
                key={i}
                type={item.type}
                id={item.id}
                placeholder={item.name}
                name={item.name}
                onChange={change}
                defaultValue={userInput[item.id]}
                required={item.required}
                onKeyDown={handleEnter}
              />
              </React.Fragment>
            );
          }

          if (item.type === 'select') {
            return (
              <React.Fragment>
              <label>{item.name}</label>
              <select key={i} id={item.id} onChange={change} name={item.name}>
                <option value="" disabled selected>{item.name}</option>
                {item.options && item.options.map((option, key) => (
                  <option key={key} id={option.id} value={option.value} name={option.name} selected={userInput[item.id] === option.id}>{option.name}</option>
                ))}
              </select>
              </React.Fragment>
            );
          }

          return null;
        })}
        {bubbles && options.map((item, i) => (
          <div
            key={i}
            className={`bubble ${item.size} bubble-${i} ${selectedBubble.includes(item.id) ? 'selected' : ''}`}
            style={{
              backgroundColor: item.color,
            }}
            onClick={e => bubbleClick(item, e)}
          >
            {item.name}
          </div>
        ))}
        {pageNumber === 0 &&
          
          <style>{'\
          .Register__buttons { position: relative; display: block; left: auto; transform: initial; margin: 0 auto; margin-top: 7rem; } '}
          </style>
        }
        {(pageNumber === 4 && userInput.reg_type_of_user !== 'travel_advisor' && userInput.reg_type_of_user !== 'Travel Advisor') &&
        <React.Fragment>
        <p>      
          <label>Country</label>
          <select 
            name="reg_country"
            id="reg_country"
            placeholder={i18n.translate('loginScreen.fields.country')}
            onChange={change}
            required
          >
            {Countries.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.code}>{c.name}</option>
            );
          })}
          </select>
          <br />
          {country === 'US' &&
          <React.Fragment>
          <p htmlFor="reg_state" className="reg_state">State/Province</p>
          <select id="reg_state" name="reg_state" onChange={change}>
            <option value="" disabled selected>
              Please select an option below
            </option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
          </React.Fragment>
          }

          {country !== 'US' &&
            <React.Fragment>
              <label>State/Province</label>
              <input
                type="text"
                id="reg_state"
                placeholder="State/Province"
                name="reg_state"
                onChange={change}
                defaultValue={userInput['reg_state']}
                required="required"
                onKeyDown={handleEnter}
              />
            </React.Fragment>
          }

          <FocusArrow />
          <FontAwesomeIcon icon={['fas', 'map']} />
          <InputLine />
        </p>

        <h4>The more you know, the more your business grows!</h4>
        <p>Thanks again for registering for TheSOURCE. As you may have noticed, right now this super app is available FREE so you can easily learn, promote, and sell like a pro no matter where you go. To maximize your benefits as a new user, the destinations, suppliers, as well as the team here at TheSOURCE, would like to stay connected with you. Please check the boxes below to continue with this free version and receive communications to help grow your business.</p>

        <span 
          className="warning"
          onClick={e => buttonClick('prev', e)}
        >
          We’ll never sell your data. We respect your privacy. Have fun!
        </span>
      </React.Fragment>
        }
        {pageNumber === 5 &&
          <React.Fragment>
          <br /><br />
            <p>    
              <label>Country</label>  
              <select 
                name="reg_country"
                id="reg_country"
                placeholder={i18n.translate('loginScreen.fields.country')}
                onChange={change}
                required
              >
                {Countries.map((c, index) => {
                const key = index;
                return (
                  <option key={key} value={c.code}>{c.name}</option>
                );
              })}
              </select>
              <FocusArrow />
              <FontAwesomeIcon icon={['fas', 'map']} />
              <InputLine />
            </p>

            <br />
            {country === 'US' &&
          <React.Fragment>
          <p htmlFor="reg_state" className="reg_state">State/Province</p>
          <select id="reg_state" name="reg_state" onChange={change}>
            <option value="" disabled selected>
              Please select an option below
            </option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
          </React.Fragment>
          }

          {country !== 'US' &&
            <React.Fragment>
              <label>State/Province</label>
              <input
                type="text"
                id="reg_state"
                placeholder="State/Province"
                name="reg_state"
                onChange={change}
                defaultValue={userInput['reg_state']}
                required="required"
                onKeyDown={handleEnter}
              />
            </React.Fragment>
          }

            <h4>The more you know, the more your business grows!</h4>
            <p>Thanks again for registering for TheSOURCE. As you may have noticed, right now this super app is available FREE so you can easily learn, promote, and sell like a pro no matter where you go. To maximize your benefits as a new user, the destinations, suppliers, as well as the team here at TheSOURCE, would like to stay connected with you. Please check the boxes below to continue with this free version and receive communications to help grow your business.</p>

            <span className="checkItem">
              <InputField
                change={change}
                fieldLabel="Stay connected to the destinations and suppliers. Your information will be shared with travel trade teams at the sponsoring destinations/suppliers only for the programs in which you are enrolled. You can always opt-out at your discretion from emails."
                fieldName="marketing_travel_brands"
                fieldType="checkbox"
                icon="envelope"
                userSelect={false}
                line={false}
                checked={false}
                title="I am open to receive further client communications."
              />
            </span>

            <span className="checkItem">
              <InputField
                change={change}
                fieldLabel="Stay connected with TheSOURCE. We want to keep you in the loop about additional learning, engagement, and networking opportunities to help grow your business.   We will never send an advertisement or product offer and never share your information. It’s been our promise since our launch in 2014!"
                fieldName="marketing_opt_in"
                fieldType="checkbox"
                icon="envelope"
                userSelect={false}
                line={false}
                checked={false}
                title="I am open to receive further invites from TravPRO/XpoPRO."
              />
            </span>

            <span 
              className="warning"
              onClick={e => buttonClick('next', e)}
            >
              We’ll never sell your data. We respect your privacy. Have fun!
            </span>
          </React.Fragment>
        }
      </div>
      <div className="Register__buttons">
        <div className="buttonWrapper">
          {pageNumber !== 0 &&
            <button
              className="white"
              onClick={e => buttonClick('prev', e)}
            >
            Back
            </button>}
          <button
            className={`${pageNumber === 0 ? 'large signUp' : 'done'}`}
            onClick={e => buttonClick('next', e)}
          >
            {pageNumber === 5 ? 'Done' : 'Next'}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RegisterPage;

RegisterPage.propTypes = {
  items: PropTypes.shape().isRequired,
  pageNumber: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleBubbleClick: PropTypes.func.isRequired,
  userInput: PropTypes.shape().isRequired,
  country: PropTypes.string.isRequired,
};
